import { useEffect, useState } from 'react';
import { useCompany } from '../context/CompanyContext';

/**
 * Hook to get company data with automatic fetching
 * Handles caching internally via CompanyContext
 */
export const useCompanyData = () => {
    const { company, fetchCompanyDetails, loading, error, isFetched } = useCompany();
    const [localLoading, setLocalLoading] = useState(true);

    useEffect(() => {
        const loadCompany = async () => {
            // Only fetch if not already fetched and not currently loading
            if (!isFetched && !loading) {
                setLocalLoading(true);
                try {
                    await fetchCompanyDetails();
                } finally {
                    setLocalLoading(false);
                }
            } else {
                setLocalLoading(false);
            }
        };
        loadCompany();
    }, [isFetched, loading]); // Remove fetchCompanyDetails from dependencies

    return {
        company,
        loading: loading || localLoading,
        error,
        logo: company?.logo,
        companyName: company?.name,
        companyId: company?._id,
    };
};

/**
 * Hook to get company logo
 * Useful when you only need the logo for display
 */
export const useCompanyLogo = () => {
    const { logo, fetchCompanyDetails, isFetched, loading } = useCompany();

    useEffect(() => {
        // Only fetch if not already fetched and not currently loading
        if (!isFetched && !loading) {
            fetchCompanyDetails();
        }
    }, [isFetched, loading, fetchCompanyDetails]); // Keep fetchCompanyDetails here since it's stable

    return logo || '/images/profile.svg';
};
